<template>
  <div class="casino-labels-container">
    <span :class="['casino-label-' + label, 'casino-label']" v-for="(label, i) in labels" :key="i"></span>
  </div>
</template>
<script>
export default {
  name: 'casinoLabels',
  props: ['labels'],
  data () {
    return {}
  },
  computed: {},
  methods: {},
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoLabels.vue